import { uris } from '../../config/environment';

export default async function loginPKS(token: string | undefined) {
    let hrefPrefix = uris.PKS_URL;
    const defaultHref = `${hrefPrefix}/Default.aspx?web=/`;

    if (token) {
        window.location.href = `${hrefPrefix}/LSLogin.aspx?token=${token}`;
    } else {
        window.location.href = defaultHref;
    }
}
